import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Doc from '../../../components/doc';
import {
  Avatar,
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles
} from '@material-ui/core';
import getInitials from 'src/utils/getInitials';
import { statisticsConstants } from 'src/_constants';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const Results = ({ className, customers, ...rest }) => {
  const classes = useStyles();
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const ConvertirEstado = (state) =>{
    switch(state){
      case "IN_REVIEW":
        return "En Revisión";
        case "APPROVED":
          return "Aprobado";
          case "CERTIFIED":
        return "Certificado";
        case "CONSULTING":
        return "Consultando";
        case "INVALID":
        return "No Aprobado";
        case "WITH_RECOMENDATIONS":
        return "Con Recomendaciones";
    }
   
  }

  if(customers!=null){
    const handleSelectAll = (event) => {
      let newSelectedCustomerIds;
  
      if (event.target.checked) {
        newSelectedCustomerIds = customers.map((customer) => customer.id);
      } else {
        newSelectedCustomerIds = [];
      }
  
      setSelectedCustomerIds(newSelectedCustomerIds);
    };
  
    const handleSelectOne = (event, id) => {
      const selectedIndex = selectedCustomerIds.indexOf(id);
      let newSelectedCustomerIds = [];
  
      if (selectedIndex === -1) {
        newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds, id);
      } else if (selectedIndex === 0) {
        newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds.slice(1));
      } else if (selectedIndex === selectedCustomerIds.length - 1) {
        newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelectedCustomerIds = newSelectedCustomerIds.concat(
          selectedCustomerIds.slice(0, selectedIndex),
          selectedCustomerIds.slice(selectedIndex + 1)
        );
      }
  
      setSelectedCustomerIds(newSelectedCustomerIds);
    };
  
    const handleLimitChange = (event) => {
      setLimit(event.target.value);
    };
  
    const handlePageChange = (event, newPage) => {
      setPage(newPage);
    };
  
  
    return (
      <Card
        className={clsx(classes.root, className)}
        {...rest}
      >
        <PerfectScrollbar>
          <Box minWidth={1050}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedCustomerIds.length === customers.length}
                      color="primary"
                      indeterminate={
                        selectedCustomerIds.length > 0
                        && selectedCustomerIds.length < customers.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                      <TableCell>
                    Nombre y Apellidos
                  </TableCell>
                  <TableCell>
                    Trámites
                  </TableCell>
              
                  <TableCell>
                    Estado
                  </TableCell>
                  <TableCell>
                    Documentos
                  </TableCell>
                  <TableCell>
                    Fecha de Registros
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customers.slice(0, limit).map((customer) => (
                  <TableRow
                    hover
                    key={customer.id}
                    selected={selectedCustomerIds.indexOf(customer.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedCustomerIds.indexOf(customer.id) !== -1}
                        onChange={(event) => handleSelectOne(event, customer.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>
                      <Box
                        alignItems="center"
                        display="flex"
                      >                     
                        <Typography
                          color="textPrimary"
                          variant="body1"
                        >
                                            {customer.type == "HOMOLOGATION" ? customer.firstname + " " + customer.lastname : customer.name+ " " + customer.surname }

                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell> 
                    {customer.type == "HOMOLOGATION" ? "Homologación" : "Solicitud de Información"}                    
                    </TableCell>
                    <TableCell>
                    {customer.type == "HOMOLOGATION" ?  ConvertirEstado(customer.state) : ConvertirEstado(customer.status)} 
                    </TableCell>   
                    <TableCell>                      
                    </TableCell>              
                    <TableCell>
                      {moment(customer.procedureDate).format('DD/MM/YYYY')}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
        <TablePagination
          component="div"
          count={customers.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Card>
    );
  }
  else {
  return (<Card
    className={clsx(classes.root, className)}
    {...rest}
  >
    <PerfectScrollbar>
      <Box minWidth={1050}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell >              
              </TableCell>
              <TableCell>
                Trámites
              </TableCell>
              <TableCell>
                Tipo
              </TableCell>
              <TableCell>
                Estado
              </TableCell>
              <TableCell>
                Documentos
              </TableCell>
              <TableCell>
                Fecha de Registros
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>            
              <TableRow>
              <TableCell>                  
                </TableCell>
                <TableCell>
                  No hay Trámites Disponibles
                </TableCell>
              </TableRow>            
          </TableBody>
        </Table>
      </Box>
    </PerfectScrollbar>    
  </Card>
);
    }
 
};

Results.propTypes = {
  className: PropTypes.string,
  customers: PropTypes.array.isRequired
};

export default Results;
